var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.65053 7.00296L10.8879 1.76537C11.0321 1.6215 11.1114 1.42914 11.1114 1.22403C11.1114 1.01881 11.0321 0.826569 10.8879 0.682472L10.429 0.223772C10.285 0.0794472 10.0925 0 9.8874 0C9.6823 0 9.49005 0.0794472 9.34596 0.223772L3.11004 6.45958C2.96537 6.60413 2.88615 6.79728 2.88672 7.00262C2.88615 7.20886 2.96526 7.40179 3.11004 7.54646L9.34015 13.7762C9.48425 13.9206 9.67649 14 9.88171 14C10.0868 14 10.2791 13.9206 10.4233 13.7762L10.8821 13.3175C11.1806 13.019 11.1806 12.533 10.8821 12.2345L5.65053 7.00296Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowIcon);
export default __webpack_public_path__ + "static/media/left-arrow-icon.92d22950d5b9bfae420c882f65b20417.svg";
export { ForwardRef as ReactComponent };